/* import __COLOCATED_TEMPLATE__ from './shopify-replacement-order-incomplete.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    notification: {
      data: {
        url: string;
        name: string;
      };
    };
  };
}

const ShopifyReplacementOrderIncomplete = templateOnlyComponent<Signature>();
export default ShopifyReplacementOrderIncomplete;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Notifications::ShopifyReplacementOrderIncomplete': typeof ShopifyReplacementOrderIncomplete;
    'notifications/shopify-replacement-order-incomplete': typeof ShopifyReplacementOrderIncomplete;
  }
}
